"use client"

import { useSyncExternalStore } from "react"
import { workspaceRecoveryHref, type WorkspaceErrorSurface } from "./error-context"
import { classes as styles, css } from "./workspace-error.styles"

const subscribe = () => () => {}

export function WorkspaceError({ surface, error, retry }: {
  surface: WorkspaceErrorSurface
  error: Error & { digest?: string }
  retry: () => void
}) {
  const home = useSyncExternalStore(subscribe,
    () => workspaceRecoveryHref(surface, window.location.hostname, window.location.pathname),
    () => `/${surface}/overview/summary`)
  const staff = surface !== "my"
  const name = surface === "crm" ? "Danaro CRM" : "My Danaro"
  return <section className={styles.surface} role="alert" aria-labelledby="workspace-error-title"><style>{css}</style>
    <meta name="robots" content="noindex, nofollow" />
    <div className={styles.content}>
      <p className={styles.brand}>{name}</p>
      <h1 id="workspace-error-title">This workspace couldn’t load</h1>
      <p>{staff
        ? "Try opening it again. If the problem continues, reload the workspace. Unsaved edits may need to be entered again."
        : "Try opening this page again or return to your overview. Check your trip or payment status before repeating an action."}</p>
      {error.digest && <p className={styles.reference}>Error reference: <code>{error.digest}</code></p>}
      <div className={styles.actions}>
        <button type="button" onClick={retry}>Try again</button>
        <button type="button" onClick={() => window.location.reload()}>Reload workspace</button>
        <a href={home}>Return to overview</a>
      </div>
      {staff && <p className={styles.help}>If it keeps happening, report the page address and error reference to your technical administrator.</p>}
    </div>
  </section>
}
